// Mapa de ícones lucide (PascalCase, vindos do design de referência) para o nome
// aceito pelo <icon-svg>. Prioriza os SVGs NATIVOS do design-system
// (`src/components/icons/svg/`); só cai em `mdi-*` (fallback via v-icon) quando
// não existe equivalente nativo — esses casos ficam agrupados e documentados no
// fim. Nome desconhecido → ícone genérico (DEFAULT_ICON).
export const LUCIDE_TO_ICON = {
  // Nativos do design-system (src/components/icons/svg/).
  Users: 'users',
  ShieldCheck: 'shield-user',
  Briefcase: 'fp-briefcase',
  Sparkles: 'stars',
  LineChart: 'line-up-graph',
  Receipt: 'receipt-items',
  Wallet: 'wallet',
  Database: 'data',
  SlidersHorizontal: 'tune',
  Cpu: 'ia-head',
  ClipboardList: 'clipboard-text',
  FileText: 'document-text',
  FileDown: 'document-download',
  BadgeCheck: 'check-circle',
  Send: 'send',
  MailCheck: 'email',
  PenLine: 'edit-pencil',
  ListChecks: 'task-square',
  FileImport: 'import-data',
  Upload: 'document-upload',
  Folder: 'folder',
  FolderPlus: 'folder-add',
  Building: 'building-solo',
  Percent: 'percentage-circle',
  Calculator: 'icons-math',
  Calendar: 'calendar',
  Filter: 'filter-new-ux',
  Tag: 'tag-right',
  Whatsapp: 'whatsapp',
  Settings: 'setting',
  Phone: 'call',
  Mail: 'email',
  Mic: 'microphone',
  Sitemap: 'hierarchy',
  AccountGroup: 'team',
  // ★ Lucide usados pelos módulos `tarefas` e `portfolio-review` (2026-08-07).
  // Sem entrada aqui o de-para cai no genérico `mdi-square-rounded-outline` — foi
  // como os dois módulos apareceram "sem ícone" na tela. Todos com equivalente
  // NATIVO no design-system, então nenhum precisou de fallback mdi.
  CheckSquare: 'task-square',
  Plus: 'plus',
  UserCheck: 'profile-tick',
  ListTree: 'hierarchy',
  CheckCircle: 'check-circle',
  MessageSquare: 'message-square',
  PieChart: 'graph-pie',
  GitCompare: 'arrow-swap-horizontal',
  History: 'document-historic',
  // Sem equivalente nativo no DS → fallback mdi documentado (renderizado via v-icon).
  Compass: 'mdi-compass-outline',
  Boxes: 'mdi-cube-outline',
  Gauge: 'mdi-gauge',
  Link2: 'mdi-link-variant',
  Layers: 'mdi-layers-outline',
  Scale: 'mdi-scale-balance',
  Target: 'mdi-target',
  FileSignature: 'mdi-file-sign',
}

const DEFAULT_ICON = 'mdi-square-rounded-outline'

export function lucideToIcon(name) {
  if (!name) return DEFAULT_ICON
  return LUCIDE_TO_ICON[name] || DEFAULT_ICON
}
